import { IYear, IYearAction } from '../../../models/filters/year';

export const YEAR_UPDATE = 'search/YEAR_UPDATE';

const initialState: IYear = {
  years: [],
  isDirty: false,
};

const defaultAction: IYearAction = {
  type: '',
  payload: {},
};

export const yearReducer = (state = initialState, action = defaultAction) => {
  switch (action.type) {
    case YEAR_UPDATE:
      return Object.assign({}, state, action.payload);

    default:
      return state;
  }
};

export const setYear = (years: string[]): IYearAction => {
  return {
    type: YEAR_UPDATE,
    payload: {
      years,
    },
  };
};

export const setDirty = (isDirty: boolean): IYearAction => {
  return {
    type: YEAR_UPDATE,
    payload: {
      isDirty,
    },
  };
};
